/**
 * Builds a redirect URL for the refresh session page.
 * @param input - The input to build the redirect URL from.
 * @returns The redirect URL for the refresh session page.
 */
export function buildRefreshSessionRedirectUrl(input?: string | URL): string {
  let url: URL;

  if (!input && typeof window !== 'undefined') {
    // Client-side default
    url = new URL(window.location.href);
  } else if (input instanceof URL) {
    url = input;
  } else if (typeof input === 'string') {
    url = new URL(input);
  } else {
    throw new Error('Invalid refresh session redirect input');
  }

  const redirectBack = encodeURIComponent(url.pathname + url.search);
  return `/refresh-session?redirectBack=${redirectBack}`;
}
